module.exports = __webpack_public_path__ + "img/bgHero.615b49da.jpg";